<template>
    <div class="container booking-container">
        <div v-if="!isLoggedIn" style="padding-top:130px;"></div>
        <booking-navigation :active-item="activeItem" ref="navigation" :title="pageTitle" :items="bookingNavigationItems" />

        <shop-search-section v-if="activeItem == 'search_shops'" @next="searchShops" ref="shopSearchSection" />
        <shop-selection-section v-else-if="activeItem == 'select_shops'" @next="selectShop" @previous="returnToShopSearch" ref="shopSelectionSection" />
        <service-selection-section v-else-if="activeItem == 'select_services'" @next="proceedToCheckout" @previous="returnToShopSelection" ref="serviceSelectionSection" />
        <checkout-section v-else-if="activeItem == 'checkout'" @next="proceedToCheckout" @previous="returnToServiceSelection" ref="checkoutSection" />
    </div>
</template>
<script>
import store from "./store";
import mixins from "@utils/mixins";

import BookingNavigation from "./partials/BookingNavigation";
import ShopSearchSection from "./partials/shop-search/ShopSearchSection";
import ShopSelectionSection from "./partials/shop-selection/ShopSelectionSection";
import ServiceSelectionSection from "./partials/service-selection/ServiceSelectionSection";
import CheckoutSection from "./partials/checkout/CheckoutSection";

export default {
    name: "BookingCreatePage",
    store,
    components: {
        BookingNavigation, ShopSearchSection, ShopSelectionSection,
        ServiceSelectionSection, CheckoutSection
    },

    computed: {
        pageTitle() {
            return this.activeItem ? this.activeItem.replace("_", " ") : "";
        },
        shop() {
            return this.$store.getters.shop;
        },
        services() {
            return this.$store.getters.services;
        },
        packages() {
            return this.$store.getters.packages;
        },
        address() {
            return this.$store.getters.address;
        },
        checkoutForm() {
            return {
                shop: this.shop,
                address: this.address,
                services: this.services,
                packages: this.packages
            }
        },
        isLoggedIn() {
            return this.$store.getters.userToken != null;
        },
    },

    data: () => ({
        activeItem: "search_shops",
        bookingNavigationItems: [
            "search_shops",
            "select_shops",
            "select_services",
            "checkout",
        ]
    }),

    methods: { 
        setActiveItem(item) {
            window.scrollTo(0,0);
            this.activeItem = item;
        },

        handleSectionErrors(section, error) {
            if (!error) return;
            console.log(error);
            this.$nextTick(() => this.$refs[section].handleErrors(error));
        },

        returnToShopSearch(error) {
            this.setActiveItem("search_shops");
            this.handleSectionErrors("shopSearchSection", error);
        },

        searchShops(payload) {
            this.setActiveItem("select_shops");
        },

        returnToShopSelection(error) {
            this.setActiveItem("select_shops");
            this.handleSectionErrors("shopSelectionSection", error);
        },

        selectShop() {
            this.$store.dispatch("setServicesAndPackages", { services: [], packages: [] });
            this.showServiceSelection();
        },

        showServiceSelection() {
            this.setActiveItem("select_services");
            this.$nextTick(() => this.$refs.serviceSelectionSection.initialize())
        },

        returnToServiceSelection(error) {
            this.showServiceSelection();
            this.handleSectionErrors("serviceSelectionSection", error);
        },

        proceedToCheckout() {
            this.setActiveItem("checkout");
            this.$nextTick(() => this.$refs.checkoutSection.initialize(this.checkoutForm), 500)
        },
        
        restoreCartData() {
            if (this.$route.query.stat !== "booking-checkout") {
                localStorage.removeItem("booking_cart");
            }
            const data = JSON.parse(localStorage.getItem("booking_cart"));
            this.$store.commit("SET_SHOP", data.shop);
            this.$store.commit("SET_ADDRESS", data.address);
            this.$store.commit("SET_SERVICES", data.services);
            this.$store.commit("SET_PACKAGES", data.packages);
            this.$store.commit("SET_SHOP_SEARCH_PARAMS", data.shopSearchParams);
            this.$nextTick(() => this.proceedToCheckout());
        }
    },

    mixins: [mixins],

    mounted() {
        if (localStorage.getItem("booking_cart")) {
            this.restoreCartData();
        }
    }


};
</script>